module.exports = __webpack_public_path__ + "img/icon04_highlight.b4f2968.png";